import { ReportsProvider } from '@reports/presentation/contexts';
import { PaymentsReportContent } from '@reports/presentation/components/specific/PaymentsReport';
import { PageLayout } from '@reports/presentation/components/base/PageLayout';

/**
 * Payments Report Page
 *
 * Entry point for the Payments Report.
 * Infrastructure dependencies are managed by composition root (initialized in App bootstrap).
 * Each report page is isolated with its own state through ReportsProvider.
 */
export const PaymentsReportPage = () => {
  return (
    <PageLayout>
      <ReportsProvider>
        <PaymentsReportContent />
      </ReportsProvider>
    </PageLayout>
  );
};
